import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('lxops_theme') || 'dark');

  // Apply theme class to <html> immediately on every change
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'light') {
      root.classList.add('light');
    } else {
      root.classList.remove('light');
    }
    localStorage.setItem('lxops_theme', theme);
  }, [theme]);

  // Sync from server when a session exists
  useEffect(() => {
    const token = localStorage.getItem('lxops_token');
    if (!token) return;
    api.get('/user/preferences')
      .then(({ data }) => {
        if (data.theme && data.theme !== theme) setTheme(data.theme);
      })
      .catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      // Persist to server in background
      const token = localStorage.getItem('lxops_token');
      if (token) {
        api.put('/user/preferences', { theme: next }).catch(() => {});
      }
      return next;
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isDark: theme === 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
};
